import moment from 'moment';
import * as React from 'react';

export function useDatetimePickers(initialMin: string, initialMax: string) {
  const [minValue, setMinValue] = React.useState<moment.Moment | null>(initialMin && moment(initialMin));
  const [maxValue, setMaxValue] = React.useState<moment.Moment | null>(initialMax && moment(initialMax));
  const [isMinValid, setIsMinValid] = React.useState<boolean>(true);
  const [isMaxValid, setIsMaxValid] = React.useState<boolean>(true);
  const [warning, setWarning] = React.useState<string>('');

  const onMinValueChange = (date: moment.Moment) => {
    setMinValue(date);
  };

  const onMaxValueChange = (date: moment.Moment) => {
    setMaxValue(date);
  };

  React.useEffect(() => {
    setIsMinValid(minValue ? minValue.isValid() : false);
    setIsMaxValid(maxValue ? maxValue.isValid() : false);

    if (minValue && maxValue && minValue > maxValue) {
      setWarning('End date is earlier than start date');
    } else {
      setWarning('');
    }
  }, [minValue, maxValue]);

  return {
    minValue,
    setMinValue,
    maxValue,
    setMaxValue,
    isMinValid,
    isMaxValid,
    warning,
    onMinValueChange,
    onMaxValueChange
  };
}
